import { ApolloProvider } from "@apollo/client/react";
import { client } from '../lib/apolloClient';
import ReviewsList from "./reviews/ReviewsList";
import ReviewsForm from "./reviews/ReviewsForm";
import { I18nContext } from "./reviews/shared";

export default function ReviewsApp({ appId, i18n }: { appId: number, i18n: object }) {
  return (
    <ApolloProvider client={client}>
      <I18nContext.Provider value={i18n}>
        <ReviewsList appId={appId} />
        <ReviewsForm appId={appId} />
      </I18nContext.Provider>
    </ApolloProvider>
  );
}
